import { DOCUMENT } from '@angular/common';
import { Component, inject, viewChild } from '@angular/core';
import { UiButtonComponent, UiEmptyStateComponent } from '@design-system';
import { BottomSheetComponent } from '../bottom-sheet/bottom-sheet.component';

/**
 * «عدم دسترسی انجام معاملات» — what a customer signed in without a کد بورس کالا is told.
 *
 * One sheet for all three entry points — ارسال سفارش on the order form, واریز and برداشت on
 * the wallet — so the wording, the icon and the way out live in one place instead of being
 * restated at each. {@link open} is the whole API: a caller raises it and returns without
 * doing the thing it was about to do, since the point is that nothing is sent and nothing
 * behind the sheet opens in the meantime.
 */
@Component({
	selector: 'app-commodity-access-denied-bottom-sheet',
	imports: [BottomSheetComponent, UiEmptyStateComponent, UiButtonComponent],
	templateUrl: './commodity-access-denied-bottom-sheet.component.html',
	host: {
		'data-cy': 'commodity-access-denied-bottom-sheet'
	}
})
export class CommodityAccessDeniedBottomSheetComponent {
	/** Where the exchange issues the code, on its own site rather than in the app. */
	private static readonly REGISTRATION_URL = 'https://mofid.ebgo.ir/StockCode';

	private readonly document = inject(DOCUMENT);
	private readonly sheet = viewChild<BottomSheetComponent>('sheet');

	open(): Promise<void> {
		return this.sheet()?.open() ?? Promise.resolve();
	}

	close(): Promise<void> {
		return this.sheet()?.close() ?? Promise.resolve();
	}

	/**
	 * The registration lives on the exchange's own site, so the tap hands the customer over to it
	 * in a new tab — opened synchronously, while the tap is still the user gesture a popup blocker
	 * asks for — and takes the sheet down behind them, so returning to the app does not land back
	 * on the sheet that sent them away.
	 */
	onRegister(): Promise<void> {
		this.document.defaultView?.open(
			CommodityAccessDeniedBottomSheetComponent.REGISTRATION_URL,
			'_blank',
			'noopener,noreferrer'
		);

		return this.close();
	}
}
